import { async } from "q";
import * as requestFromServer from "./dashboardCrud";
import { dashboardSlice } from "./dashboardSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SERVER_MESSAGES } from "../../../utils/constants";
import { formatDates } from "../../../utils/common";
import { format } from "date-fns";

const { actions } = dashboardSlice;

// export const fetchAllCenters = () => async (dispatch) => {
//   return await requestFromServer
//     .getAllCeters()
//     .then((response) => {
//       const entities = response.data?.data;
//       dispatch(actions.AllCentersFetch(entities));
//     })
//     .catch((error) => {
//       toast.error("Some thing went wrong");
//     });
// };

export const fetchAllSubCenter = (centerId) => async (dispatch) => {
  return await requestFromServer
    .getAllSubcenter(centerId)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllSubCenterFetch(entities));
    })
    .catch((error) => {
      toast.error("Some thing went wrong");
    });
};

export const fetchAllCountry = () => async (dispatch) => {
  return await requestFromServer
    .getAllCountry()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllCountryFetch(entities));
    })
    .catch((error) => {
      toast.error("Something went wrong");
    });
};

// export const fetchAllDept = (id) => async (dispatch) => {
//
//   return await requestFromServer
//     .getAllDepartments(id)
//     .then((response) => {

//       const entities = response.data?.data;
//        dispatch(actions.AllDeptFetch(entities));
//     })
//     .catch((error) => {
//       toast.error("Something went wrong");
//     });
// };

export const fetchAllCity = (cityId) => async (dispatch) => {
  return await requestFromServer
    .getCityByCountryId(cityId)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllCityFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchStandByVehicles = (body) => async (dispatch) => {
  return await requestFromServer
    .getVehiclesByCenterAndSubcenterId(body)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllVehiclesByCenterAndSubCenterId(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong.");
    });
};

export const fetchDashboardVehicles = (body) => async (dispatch) => {
  return await requestFromServer
    .getDashboardVehicle(body)
    .then((response) => {
      const entities = response.data.data;
      dispatch(actions.dashboardVehicles(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const updateVehicelStatus = (body) => async (dispatch) => {
  return await requestFromServer
    .updateVehicleStatus(body)
    .then((response) => {
      toast.success("Successfully Updated");
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const getLastTrips = (body) => async (dispatch) => {
  return await requestFromServer
    .getLastTrips(body)
    .then((response) => {
      dispatch(actions.lastTripsVehicles(response?.data?.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const updateTripLog = (payload) => async (dispatch) => {
  return await requestFromServer
    .updateTripLog(payload)
    .then((response) => {
      const updatedUser = response?.data?.data;
      dispatch(actions.updateData(response?.data?.data));
      toast.success("Successfully Updated", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
};

export const alaramTime = () => async (dispatch) => {
  return await requestFromServer
    .getAlaramTime()
    .then((response) => {
      dispatch(actions.AlaramTime(response?.data?.data));
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
    });
};

export const getEmployeeHierarchy = (level) => (dispatch) => {
  return requestFromServer
    .getEmployeeHierarchy(level)
    .then((res) => {
      const { levelList, employeeList } = res.data?.data;
      dispatch(actions.EmployeeHierarchyFetched({ levelList, employeeList }));
    })
    .catch((error) => {
      console.error("Error fetching employee hierarchy:", error);
      dispatch(
        actions.EmployeeHierarchyFetched({ levelList: [], employeeList: [] }),
      );
      error.clientMessage = "Can't Get Employee Hierarchy";
    });
};

export const getLogedInEmployee = () => (dispatch) => {
  return requestFromServer
    .getEmployeeProfile()
    .then((res) => {
      const data = res.data?.data;
      dispatch(actions.fetchLogedInInEmployee(data));
    })
    .catch((error) => {
      console.error("Error fetching employee:", error);
      dispatch(actions.fetchLogedInInEmployee(null));
      error.clientMessage = "Can't Get Employee";
    });
};

export const fetchLeaveBalances = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getAllLeaveBalances({ employeeId })
      .then((response) => {
        dispatch(actions.LeaveBalancesFetched(response));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Leave Balances";
      });
  } else {
    dispatch(actions.LeaveBalancesFetched([]));
  }
};

export const fetchProfileInfo = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getProfileInfo({ Id: employeeId })
      .then((response) => {
        dispatch(actions.ProfileInfoFetched(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Profile Info";
      });
  } else {
    dispatch(actions.ProfileInfoFetched(null));
  }
};

export const fetchContactInfo = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getContactInfo({ Id: employeeId })
      .then((response) => {
        dispatch(actions.ContactInfoFetched(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Contact Info";
      });
  } else {
    dispatch(actions.ContactInfoFetched(null));
  }
};

export const fetchExperienceInfo = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getExperienceInfo({ Id: employeeId })
      .then((response) => {
        dispatch(actions.ExperienceInfoFetched(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Experience Info";
      });
  } else {
    dispatch(actions.ExperienceInfoFetched(null));
  }
};

export const fetchAcademicInfo = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getAcademicInfo({ Id: employeeId })
      .then((response) => {
        dispatch(actions.AcademicInfoFetched(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Academic Info";
      });
  } else {
    dispatch(actions.AcademicInfoFetched(null));
  }
};

export const fetchSkillsInfo = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getSkillsInfo({ Id: employeeId })
      .then((response) => {
        dispatch(actions.SkillsInfoFetched(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find Skills Info";
      });
  } else {
    dispatch(actions.SkillsInfoFetched(null));
  }
};

export const fetchReportingEmployee = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getReportingEmployee({ Id: employeeId })
      .then((response) => {
        dispatch(
          actions.ReportingEmployeeFetched(response?.data?.data || null),
        );
      })
      .catch((error) => {
        error.clientMessage = "Can't find reporting employee";
      });
  } else {
    dispatch(actions.ReportingEmployeeFetched(null));
  }
};

export const fetchLoanDetail = (employeeId) => async (dispatch) => {
  if (employeeId) {
    return requestFromServer
      .getLoanDetail({ Id: employeeId })
      .then((response) => {
        dispatch(actions.AllLoanFetch(response?.data?.data || null));
      })
      .catch((error) => {
        error.clientMessage = "Can't find loan";
      });
  } else {
    dispatch(actions.AllLoanFetch(null));
  }
};

export const fetchHolidayDetail = (employeeId) => async (dispatch) => {
  return requestFromServer
    .getHolidayDetail({ Id: employeeId })
    .then((response) => {
      dispatch(actions.AllHolidayFetch(response?.data?.data || null));
    })
    .catch((error) => {
      error.clientMessage = "Can't find Holidays";
    });
};

export const getPayrollMonth = (employeeId) => (dispatch) => {
  if (!employeeId) {
    dispatch(actions.PayrollMonthFetched({ payrollData: null }));
  } else {
    return requestFromServer
      .getPayrollMonth({ employeeId })
      .then((res) => {
        const payrollData = res.data?.data;
        dispatch(actions.PayrollMonthFetched({ payrollData }));
      })
      .catch((error) => {
        dispatch(actions.PayrollMonthFetched({ payrollData: null }));
        error.clientMessage = "Can't Get Payroll Data";
      });
  }
};

//// dashbaord related service

export const fetchDashboardAlert = (body) => async (dispatch) => {
  return await requestFromServer
    .getDashboardAlert(body)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllDashboardAlertsFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.AllDashboardAlertsFetch([]));
    });
};

export const fetchSummary = (filter) => async (dispatch) => {
  return await requestFromServer
    .getSummary(filter)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.SummaryFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.SummaryFetch({}));
    });
};

export const fetchSummaryDetail = (filter, name) => async (dispatch) => {
  if (filter && name) {
    return await requestFromServer
      .getSummaryDetail({ filter, name })
      .then((response) => {
        const entities = response.data?.data;
        dispatch(actions.SummaryDetailFetch(entities));
      })
      .catch((error) => {
        dispatch(actions.SummaryDetailFetch(null));
      });
  } else {
    dispatch(actions.SummaryDetailFetch(null));
  }
};

// export const fetchRecruitmentSummary = (filter) => async (dispatch) => {
//   return await requestFromServer
//     .getRecruitmentSummary(filter)
//     .then((response) => {
//       const entities = response.data?.data;
//       dispatch(actions.RecruitmentSummaryFetch(entities));
//     })
//     .catch((error) => {
//       dispatch(actions.RecruitmentSummaryFetch({}));
//     });
// };

export const fetchAnnouncementData = () => async (dispatch) => {
  return await requestFromServer
    .getAnnouncment()
    .then((response) => {
      const data = response.data?.data;
      dispatch(actions.AnnouncementFetch(data));
    })
    .catch((error) => {
      dispatch(actions.AnnouncementFetch([]));
    });
};

export const fetchExitReasonData = (Id) => async (dispatch) => {
  return await requestFromServer
    .getExitReason(Id)
    .then((response) => {
      const data = response.data?.data;
      dispatch(actions.AllExitReasonListFetch(data));
    })
    .catch((error) => {
      dispatch(actions.AllExitReasonListFetch([]));
    });
};

export const getEmployeeProfileInfo = (setProfileInfo) => (dispatch) => {
  return requestFromServer
    .getEmpProfileInfo()
    .then((res) => {
      setProfileInfo(res?.data?.data);
      sessionStorage.setItem("profile_info", JSON.stringify(res?.data?.data));
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
};

export const getEmployeePortalInfo = (setLoading, detailViewType) => (
  dispatch,
) => {
  setLoading(true);
  return requestFromServer
    .getPortalInfo({ detailViewType })
    .then((res) => {
      dispatch(actions.PortalInfoFetched(res?.data?.data));
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
      toast.error(error?.response?.data?.message || "Something went wrong", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
};

export const getCurrentTimeAndAttendance = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);

    // timezone string (better for backend)
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // 1. Get server time
    const timeRes = await requestFromServer.getCurrentDateTime(timeZone);
    const localDate = timeRes?.data;

    dispatch(actions.CurrentDateTimeFetch(localDate));

    // fallback safety
    const now = localDate?.dateTime ? new Date(localDate.dateTime) : new Date();

    // 2. Prepare payload
    const payload = {
      date: format(now, "yyyy-MM-dd"),
      // timeZone, //
      timeZone: now.getTimezoneOffset(), //
      clientNow: now.toISOString(),
    };

    // 3. Get attendance
    const attendanceRes = await requestFromServer.getAttendance(payload);
    const attendance = attendanceRes?.data?.data;

    dispatch(actions.CurrentAttFetch(attendance));

    return {
      localDate,
      attendance,
    };
  } catch (error) {
    console.error("getCurrentTimeAndAttendance error:", error);
  } finally {
    setLoading(false); // 👈 always run
  }
};

export const createAttendance = (body, setLoading) => (dispatch) => {
  return requestFromServer
    .createAttendance(body)
    .then((res) => {
      // dispatch(actions.CurrentAttFetch(res?.data?.data));
      toast.success("Attendance Mark Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLoading(false);
    })
    .catch((error) => {
      toast.error(
        error?.response?.data?.message || SERVER_MESSAGES.insertedFail,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      setLoading(false);
    });
};

export const fetchAllUserData = (Id) => async (dispatch) => {
  return await requestFromServer
    .getAllUser(Id)
    .then((response) => {
      const data = response.data?.data;
      dispatch(actions.AllUserFetch(data));
    })
    .catch((error) => {
      dispatch(actions.AllUserFetch([]));
    });
};
export const fetchAllAuditTablesName = (userId) => async (dispatch) => {
  return await requestFromServer
    .getAllAuditTablesName({ userId })
    .then((response) => {
      const data = response.data?.data;
      dispatch(actions.AllAuditTablesNameFetch(data));
    })
    .catch((error) => {
      dispatch(actions.AllAuditTablesNameFetch([]));
    });
};

export const fetchAllFiscalYearDataBySubsidiaryId = (subsidiaryId) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllFiscalYearBySubsidiaryId({ subsidiaryId })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllFiscalYearBySubListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllDepartmentBySubsidiaryIds = (subsidiaryIds) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllDepartmentBySubsidiaryIds({ subsidiaryIds })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllDepartmentBysSubIdsListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllAppraisalPeriod = (employeeId) => async (dispatch) => {
  return await requestFromServer
    .getAllAppraisalPeriod({ employeeId })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllAppraisalPeriodListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};
export const fetchAllAppraisalPeriodDataBySubsidiaryId = (
  subsidiaryId,
) => async (dispatch) => {
  return await requestFromServer
    .getAllAppraisalPeriodBySubsidiaryId({ subsidiaryId })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllAppraisalPeriodBySubListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllApprovedResignedEmp = () => async (dispatch) => {
  return await requestFromServer
    .getAllApprovedResignedEmp({})
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllApprovedResignedEmpListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchGeoLocationBySubsidiary = (subsidiaryId) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllGeoLocationBySubsidiary({ subsidiaryId })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllGeoLocationFetchedFetch(entities));
    })
    .catch((error) => {
    });
};

export const fetchEmpDeviceId = (employeeId) => async (dispatch) => {
  return await requestFromServer
    .getDeviceIdByEmpId({ employeeId })
    .then((response) => {
      const entities = [...response.data?.data];
      return entities;
    })
    .catch((error) => {
    });
};

export const fetchAllEarning = () => async (dispatch) => {
  return await requestFromServer
    .getAllEarning()
    .then((response) => {
      const entities = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      dispatch(actions.AllEarningFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchSeparatedEmployeeById = (Id) => async (dispatch) => {
  return await requestFromServer
    .getSeparatedEmployeeById(Id)
    .then((response) => {
      dispatch(actions.SeparatedEmployeeFetch(response.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const FetchAllSalaryRoundingByFilters = () => async (dispatch) => {
  return await requestFromServer
    .getAllSalaryRoundingByFilters()
    .then((response) => {
      dispatch(actions.SalaryRoundingFetch(response?.data?.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const FetchProfileDetailInfo = (id) => async (dispatch) => {
  return await requestFromServer
    .getProfileDetailInfo(id)
    .then((response) => {
      dispatch(actions.ProfileDetailInfoFetch(response?.data?.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const FetchAllApprovedFSEmp = (body) => async (dispatch) => {
  return await requestFromServer
    .getAllApprovedFSEmp(body)
    .then((response) => {
      dispatch(actions.FSApprovedEmpFetch(response?.data?.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const FetchAllTaxYearSetup = (subsidiaryId) => async (dispatch) => {
  return await requestFromServer
    .getAllTaxYearSetup(subsidiaryId)
    .then((response) => {
      dispatch(actions.TaxYearSetupFetch(response?.data?.data));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const requestRaisedBySenior = () => async (dispatch) => {
  return await requestFromServer
    .requestRaisedBySenior()
    .then((response) => {
      dispatch(actions.requestRaisedBySenior(response?.data?.data));
    })
    .catch((error) => { });
};

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await requestFromServer
    .uploadFiles(formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || SERVER_MESSAGES.fileFail, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
};
export const FetchAllFacilitatorEmployee = (ticketTypeId) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllFacilitatorEmployee(ticketTypeId)
    .then((response) => {
      dispatch(actions.FacilitatorEmployeeFetch(response?.data?.data));
    });
};

export const FetchAllFacilitatorTicketType = () => async (dispatch) => {
  return await requestFromServer
    .getAllFacilitatorTicketType()
    .then((response) => {
      dispatch(actions.AllFacilitatorTicketTypeFetch(response?.data?.data));
    })
    .catch((error) => {
      toast.error("Something went wrong");
    });
};

export const updateDefaultSubsidiary = (Id) => async (dispatch) => {
  return await requestFromServer
    .updateDefaultSubsidiary({ Id })
    .then((response) => {
      return;
    })
    .catch((error) => {
      toast.error(
        error?.response?.data?.message || SERVER_MESSAGES.updatedFail,
      );
    });
};

export const fetchModuleRights = () => async (dispatch) => {
  return await requestFromServer
    .getModuleRights()
    .then((response) => {
      let data = response?.data?.data || [];
      // agar employee ka right then set seperation after employee pass employee value 1 as per guideline
      if (Array.isArray(data) && data.length > 0) {
        const index = data.findIndex((item) => item?.value === 1);

        if (index !== -1) {
          data.splice(index + 1, 0, {
            value: "separation",
            label: "Separation",
            allow: true,
          });
        }
      }

      dispatch(actions.ModuleRightFetched(data));
    })
    .catch(() => {
      dispatch(actions.ModuleRightFetched([]));
    });
};

export const fetchUsersByCompanyId = (Id) => async (dispatch) => {
  return await requestFromServer
    .getUsersByCompanyId({ Id })
    .then((response) => {
      let data = response?.data?.data || [];
      dispatch(actions.UsersByCompanyFetched(data));
    })
    .catch(() => {
      dispatch(actions.UsersByCompanyFetched([]));
    });
};

export const updateAndSetPortalDashboardView = (body, setVal) => async (
  dispatch,
) => {
  return await requestFromServer
    .updatePortalDashboardType(body)
    .then((response) => {
      let data = response?.data?.data;
      setVal(data);
    });
};

export const fetchAllActiveCustomers = () => async (dispatch) => {
  return await requestFromServer
    .getAllActiveCustomers()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllActiveCustomerFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.AllActiveCustomerFetch([]));
    });
};

export const fetchAllProjects = (employeeId = null) => async (dispatch) => {
  return await requestFromServer
    .getAllProjects({ employeeId })
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllProjectFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.AllProjectFetch([]));
    });
};

export const fetchAllTicketStatus = () => async (dispatch) => {
  return await requestFromServer
    .getAllTicketStatus()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllTicketStatusFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.AllTicketStatusFetch([]));
    });
};

export const fetchAllTicket = (
  employeeId = null,
  projectId = null,
  notCompleted = false,
) => async (dispatch) => {
  return await requestFromServer
    .getAllTicket({ employeeId, projectId, notCompleted })
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllTicketFetch(entities));
    })
    .catch((error) => {
      dispatch(actions.AllTicketFetch([]));
    });
};

export const fetchTicketById = (Id) => async (dispatch) => {
  return await requestFromServer
    .getTicketById({ Id })
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.TicketFetch(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.TicketFetch({}));
    });
};

export const fetchMasterTicketType = () => async (dispatch) => {
  return await requestFromServer
    .getAllMasterTicketType()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllMasterTicketTypeFetched(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.AllMasterTicketTypeFetched({}));
    });
};

export const fetchCompanyEmployeesData = () => async (dispatch) => {
  return await requestFromServer
    .getAllCompanyEmployeesData()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllCompanyEmployeesDataFetched(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.AllCompanyEmployeesDataFetched({}));
    });
};

export const fetchCurrentParentTask = () => async (dispatch) => {
  return await requestFromServer
    .getAllCurrentParentTask()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllCurrentParentTaskFetched(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.AllCurrentParentTaskFetched({}));
    });
};

export const fetchAllAlertTasks = () => async (dispatch) => {
  return await requestFromServer
    .getAllAlertTasks()
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.AllAlertTaskFetched(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.getAllAlertTasks({}));
    });
};


export const fetchAttLogsByDate = (body) => async (dispatch) => {
  return await requestFromServer
    .getAttLogsByDate(body)
    .then((response) => {
      const entities = response.data?.data;
      dispatch(actions.DateWiseAttLogsFetched(entities));
      return entities;
    })
    .catch((error) => {
      dispatch(actions.DateWiseAttLogsFetched({}));
    });
};

export const fetchAllBudgetYearDataBySubsidiaryId = (subsidiaryId) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllBudgetYearBySubsidiaryId({ subsidiaryId })
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllBudgetYearBySubListFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};
export const fetchAllBudgetRequest = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllBudgetRequest(body)
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllBudgetRequestFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllCompanyDepartment = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllComDept()
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllCompDeptFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllDesignationByDepId = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllDesignationByDepId(body)
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllDesignationByhDeptFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};

export const fetchAllParentSubsidiaries = () => async (dispatch) => {
  return await requestFromServer
    .getAllParentSubsidiaries()
    .then((response) => {
      const raw = response.data?.data || [];
      // Map to { value, label } for SearchSelect dropdown
      const options = raw.map((item) => ({
        value: item.Id,
        label: item.name,
      }));
      dispatch(actions.AllParentSubsidiariesFetch(options));
    })
    .catch((error) => {
      dispatch(actions.AllParentSubsidiariesFetch([]));
    });
};
export const fetchAllAssetModelName =
  (asset_makeId = null, asset_categoryId = null) =>
    async (dispatch) => {
      if (
        asset_makeId &&
        typeof asset_makeId === "object" &&
        !Array.isArray(asset_makeId)
      ) {
        asset_categoryId = asset_makeId.asset_categoryId ?? null;
        asset_makeId = asset_makeId.asset_makeId ?? null;
      }

      const response = await requestFromServer.getAllAssetModelName({
        asset_makeId,
        asset_categoryId,
      });

      dispatch(
        actions.AllAssetModelNameFetch(response.data?.data || [])
      );
    };

export const fetchAllRegisterAssetName =
  (body = {}) =>
  async (dispatch) => {
    try {
      const response = await requestFromServer.getAllRegisterAssetName({
        asset_categoryId: body?.asset_categoryId ?? null,
        asset_modelId: body?.asset_modelId ?? null,
        status: body?.status ?? null,
        subsidiaryId: body?.subsidiaryId ?? null,
      });

      dispatch(
        actions.AllRegisterAssetNameFetch(response.data?.data || [])
      );
    } catch (error) {
      console.error("fetchAllRegisterAssetName error:", error);
      // toast.error("Something went wrong");
    }
  };

export const fetchAllPresentUnassignedCategory = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllPresentUnassignedCategory(body)
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllPresentUnassignedCategoryFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};



export const fetchAllPresentUnassignedMakeCompany = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAllPresentUnassignedMakeCompany(body)
    .then((response) => {
      const entities = [...response.data?.data];
      dispatch(actions.AllPresentUnassignedMakeCompanyFetch(entities));
    })
    .catch((error) => {
      // toast.error("Something went wrong");
    });
};


export const fetchAllAssetInspectionListById = (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAssetInspectionListById(body)
    .then((response) => {
      const entities = [...response.data?.data.list];
      console.log("entities5555555555", entities);
      dispatch(actions.AllAssetInspectionListFetch(entities));
    })
    .catch((error) => {
      console.log("error111", error);
      // toast.error("Something went wrong");
    });
};
export const fetchAssetAssignmentListByEmpId= (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAssetAssignmentListByEmpId(body)
    .then((response) => {
      const entities = [...(response.data?.data?.rows || [])];
     
      dispatch(actions.AllAssetAssignmentListByEmpIdFetch(entities));
    })
    .catch((error) => {
      console.log("error111", error);
      // toast.error("Something went wrong");
    });
};

export const fetchAssetChecklistById= (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getAssetChecklistById(body)
    .then((response) => {
      const entities = [...(response.data?.data || [])];
     
      dispatch(actions.AllAssetChecklistByIdFetch(entities));
    })
    .catch((error) => {
      console.log("error111", error);
      // toast.error("Something went wrong");
    });
};


export const fetchOvertimeEntitledEmployeesData= (body) => async (
  dispatch,
) => {
  return await requestFromServer
    .getOvertimeEntitledEmployeesData(body)
    .then((response) => {
      const entities = [...(response.data?.data || [])];
     
      dispatch(actions.AllOvertimeEntitledEmployeesFetch(entities));
    })
    .catch((error) => {
      console.log("error111", error);
      // toast.error("Something went wrong");
    });
};

export const fetchAttendanceTaskLogs = (employeeId, loggedDate,toDate) => (dispatch) => {
  if (!employeeId || !loggedDate) {
     dispatch(actions.AttendanceTaskLogsFetched([]));
    return;
  }



  return requestFromServer
    .getAttendanceTaskLogs(employeeId, loggedDate,toDate)
    .then((response) => {
      const taskLogs = [...(response.data?.data?.rows || [])];
      dispatch(
        actions.AttendanceTaskLogsFetched(
          taskLogs
        )
      );

  
    })
    .catch((error) => {
      dispatch(
        actions.AttendanceTaskLogsFetched([])
      );
       console.log("Can't find Attendance Task Logs");

    
    });
};
export const fetchAllTaskDetail = (taskId) => (dispatch) => {
  if (!taskId) {
     dispatch(actions.TaskDetailsFetched([]));
    return;
  }



  return requestFromServer
    .getAllTaskDetail(taskId)
    .then((response) => {
      console.log("response1111",response.data?.data)
    const taskDetails = response.data?.data || {
        TaskInfo: null,
        TaskTimeLogs: [],
        TaskDetail: [],
      };

      dispatch(
        actions.TaskDetailsFetched(
          taskDetails
        )
      );

  
    })
    .catch((error) => {
      dispatch(
        actions.TaskDetailsFetched([])
      );
       console.log("Can't find Task Details");

    
    });
};

export const fetchApplicantSelectedStatusForDisabled= () => async (
  dispatch,
) => {
  return await requestFromServer
    .getApplicantSelectedStatusForDisabled()
    .then((response) => {
      const entities = [...(response.data?.data || [])];
     
      dispatch(actions.ApplicantStatusForDisabledFetched(entities));
    })
    .catch((error) => {
     
      // toast.error("Something went wrong");
    });
};

